import React from 'react';
import { useReportes } from './ReportesContex';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import '../../styles/reportes.css';

// Informes que solo llegan hasta Línea (sin selector de Celda)
const INDICES_SOLO_LINEA = [1, 2, 5, 8, 9];
// Informes que solo llegan hasta Área (el selector de Línea lo maneja el propio informe)
const INDICES_SOLO_AREA = [8];

export default function SelectJerarquiaReportes() {
    const {
        areas,
        filteredLines,
        hierCeldas,
        selectedArea,
        setSelectedArea,
        selectedLinea,
        setSelectedLinea,
        selectedCelda,
        setSelectedCelda,
        selectedIndex,
    } = useReportes();

    const showCelda = !INDICES_SOLO_LINEA.includes(selectedIndex);
    const showLinea = !INDICES_SOLO_AREA.includes(selectedIndex);

    const plantaNombre = process.env.REACT_APP_PLANT_NAME || 'Planta';

    const handleAreaChange = (e) => {
        const val = e.target.value;
        const area = val !== '' ? areas.find((a) => String(a.area1) === String(val)) || null : null;
        setSelectedArea(area);
    };

    const handleLineaChange = (e) => {
        const val = e.target.value;
        const linea = val !== '' ? filteredLines.find((l) => String(l.id) === String(val)) || null : null;
        setSelectedLinea(linea);
    };

    const handleCeldaChange = (e) => {
        const val = e.target.value;
        const celda = val !== '' ? hierCeldas.find((c) => String(c.id) === String(val)) || null : null;
        setSelectedCelda(celda);
    };

    return (
        <div className="selectJerarquia">
            <FormControl className="selectJerarquia-item">
                <InputLabel shrink>Planta</InputLabel>
                <Select value="planta" disabled>
                    <MenuItem value="planta">{plantaNombre}</MenuItem>
                </Select>
            </FormControl>

            <FormControl className="selectJerarquia-item">
                <InputLabel id="rep-select-area-label">Área</InputLabel>
                <Select
                    labelId="rep-select-area-label"
                    value={selectedArea?.area1 ?? ''}
                    onChange={handleAreaChange}
                >
                    <MenuItem value="">Todas las áreas</MenuItem>
                    {areas.map((area) => (
                        <MenuItem key={area.area1} value={area.area1}>
                            {area.nombre}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            {selectedArea && showLinea && (
                <FormControl className="selectJerarquia-item">
                    <InputLabel id="rep-select-linea-label">Línea</InputLabel>
                    <Select
                        labelId="rep-select-linea-label"
                        value={selectedLinea?.id ?? ''}
                        onChange={handleLineaChange}
                    >
                        <MenuItem value="">Todas las líneas</MenuItem>
                        {filteredLines.map((line) => (
                            <MenuItem key={line.id} value={line.id}>
                                {line.nombre}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}

            {selectedLinea && showCelda && (
                <FormControl className="selectJerarquia-item">
                    <InputLabel id="rep-select-celda-label">Celda</InputLabel>
                    <Select
                        labelId="rep-select-celda-label"
                        value={selectedCelda?.id ?? ''}
                        onChange={handleCeldaChange}
                    >
                        <MenuItem value="">Todas las celdas</MenuItem>
                        {hierCeldas.map((celda) => (
                            <MenuItem key={celda.id} value={celda.id}>
                                {celda.nombre}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
        </div>
    );
}
